module.exports = __webpack_public_path__ + "img/arrUp.9b32283b.png";